import IBHipExtensionTerminalSwing from '@/pages/ReportV2/components/Modals/assets/IBHipExtensionTerminalSwing.png';
import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
import React from 'react';
// Slides
import { SwiperSlide } from 'swiper/react';

import { VerticalSwiper } from '@/components/swiper';

// Styles
import styles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

export const HipExtensionTerminalSwingModalContent = () => {
  return (
    <>
      <VerticalSwiper>
        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='12' size-lg='6' size-xl='6'>
                <div>
                  <IonImg class={styles.avatar} src={IBHipExtensionTerminalSwing} />
                </div>
              </IonCol>
              <IonCol size='12' size-lg='6' size-xl='6'>
                <div>
                  After midswing the leg keeps extending by hip flexion and knee extension. At terminal swing the
                  direction of hip movement reverses (from flexion to extension) partly due to the eccentric acting
                  hamstrings.
                  <br></br>
                  <br></br>
                  This increases tension on muscles, preparing the hip and knee for processing the ground reacting
                  forces which occur after initial contact and the accomplishment of a good balance.
                  <br></br>
                  <br></br>
                  When maximum hip flexion is not reached until initial contact, there will be lack of protecting
                  pre-tension. The shock absorbing mechanism will not be able to function optimally, increasing the
                  impact on joints significantly.
                  <br></br>
                  <br></br>
                  The cause of a compromised timed hip flexion can be found in either leg:
                  <ol type='A'>
                    <li>The swing is too slow and or hip ROM to low due to a weak push off</li>
                    <li>
                      Lack of time and being forced to land early due to instability and or control in the opposite leg
                      (being in terminal stance)
                    </li>
                  </ol>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>
      </VerticalSwiper>
    </>
  );
};
